__turbopack_context__.v({
  "gameRootContent": "styles-module-scss-module__BmYu0G__gameRootContent",
});
